export const ActionTypes = {
  FETCH_ALL: 'services/audit_logs/fetch_all',
  SET_ALL: 'services/audit_logs/set_all',
  SET_LOADER_STATUS: 'services/audit_logs/set_loader_status',
  FETCH_USERS: 'services/audit_logs/fetch_users',
  SET_USERS: 'services/audit_logs/set_users',
};

const fetchAll = ({ auditLogsParams }) => ({
  auditLogsParams,
  type: ActionTypes.FETCH_ALL,
});

const setAll = ({ allAuditLogs }) => ({
  allAuditLogs,
  type: ActionTypes.SET_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchUsers = () => ({
  type: ActionTypes.FETCH_USERS,
});

const setUsers = ({ users }) => ({
  users,
  type: ActionTypes.SET_USERS,
});

const Actions = {
  fetchAll,
  setAll,
  setLoader,
  fetchUsers,
  setUsers,
};

export default Actions;
